import React from "react";
import PropTypes from "prop-types";

const TimerDisplay = ({ type, value }) => {
	return (
		<div className="timer-display">
			<p className="timer-display__value animate--count-up">{value}</p>
			<p className="timer-display__type">{type}</p>
		</div>
	);
};

TimerDisplay.propTypes = {
	value: PropTypes.any,
	type: PropTypes.any,
};

export default TimerDisplay;
